import React from 'react';

/**
 * 텍스트 공지 본문: 배지 → 제목 → 설명 → 특징 목록.
 * image({ src, alt })가 있으면 설명·특징 대신 이미지 한 장을 보여준다 (썸네일 공지).
 */
const TextNoticeBody = ({ announcement }) => {
  const features = Array.isArray(announcement.features) ? announcement.features : [];
  const image = announcement.image?.src ? announcement.image : null;

  return (
    <div className={`announcement-notice${image ? ' announcement-notice--image' : ''}`}>
      <div className="announcement-modal__head">
        {announcement.icon && (
          <span aria-hidden="true" className="announcement-modal__icon">{announcement.icon}</span>
        )}
        {announcement.badge && (
          <span className="announcement-modal__badge">{announcement.badge}</span>
        )}
        <p className={`announcement-modal__title${image ? ' announcement-modal__title--compact' : ''}`}>
          {announcement.title}
        </p>
      </div>
      {image ? (
        <div className="announcement-notice__image">
          <img
            alt={image.alt || ''}
            decoding="async"
            draggable="false"
            height="840"
            src={image.src}
            width="840"
          />
        </div>
      ) : (
        <>
          {announcement.description && (
            <p className="announcement-notice__description">{announcement.description}</p>
          )}
          {features.length > 0 && (
            <ul className="announcement-modal__features">
              {features.map((feature, index) => (
                <li className="announcement-modal__feature" key={index}>{feature}</li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default TextNoticeBody;
